import React from 'react';

const SliderPrevArrow = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="26" viewBox="0 0 34 26" fill="none">
      <path
        d="M32.8884 13.0135H1.7773M1.7773 13.0135L12.8884 1.90234M1.7773 13.0135L12.8884 24.1246"
        stroke="currentColor"
        strokeWidth="2.22222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SliderPrevArrow;
